import axios from "axios";

// Tables and areas (owner, 2026-10-24: "I can't manipulate my own tables and areas").
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/tables`;
const auth = token => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

export const listTables = token => axios.get(API, auth(token)).then(r => r.data);
export const createTable = (body, token) => axios.post(API, body, auth(token)).then(r => r.data);
export const updateTable = (id, body, token) => axios.put(`${API}/${id}`, body, auth(token)).then(r => r.data);
export const deleteTable = (id, token) => axios.delete(`${API}/${id}`, auth(token));
/** Rename an area on its tables and in every captain's section, in one step. */
export const renameArea = (oldName, newName, token) =>
  axios.post(`${API}/areas/rename`, { old_name: oldName, new_name: newName }, auth(token)).then(r => r.data);
